import { createContext, memo, useContext, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import unicode from "./languages/unicode.json"
import zawgyi from "./languages/zawgyi.json"
import english from "./languages/en.json"

export const LangContext = createContext({});

export const LangProvider = memo(({ children }) => {
  let [lang, setLang] = useState("en"); //zg uni en
  
  
  const changeLang = (val) => {
    if(val == "zg" || val == "uni" || val == "en") {
      setLang(val);
      localStorage.setItem("lang",val)
    }
  }

  useEffect(()=>{
    const storedVal = localStorage.getItem("lang");
    if(storedVal) setLang(storedVal);
  }, []);

  const langObj = {lang, changeLang}

  return (
    <LangContext.Provider value={langObj}>{children}</LangContext.Provider>
  );
});


export const useLang = () => {
  const context = useContext(LangContext);
  if (!context) {
    throw new Error('useLang must be used within an LangProvider');
  }
  const {lang} = context;
  let text;
  if(lang == "uni"){
      text = unicode;
  }else if(lang == 'zg'){
      text = zawgyi;
  }else{
      text = english
  }
  return {text,...context}
};

export const pageContext = createContext();


